import { getFormField } from '../../utils';

function delayPromise(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

async function pollEndpoint(fetchFn, shouldContinue, delay) {
    await fetchFn();
    if (shouldContinue()) {
        await delayPromise(delay);
        await pollEndpoint(fetchFn, shouldContinue, delay);
    }
}

function removeValidationForUnmodifiedFields(form, validationFields) {
    if (!form) {
        return;
    }

    return validationFields.reduce((fields, validationField) => {
        const formField = getFormField(form, validationField.id);

        if (validationField.fields?.length) {
            return [
                ...fields,
                {
                    ...validationField,
                    fields: removeValidationForUnmodifiedFields(formField, validationField.fields),
                },
            ];
        }

        if (!validationField.isValid && !formField.isModified) {
            return fields;
        }

        return [
            ...fields,
            validationField,
        ];
    }, []);
}

export {
    pollEndpoint,
    removeValidationForUnmodifiedFields,
};
